import { Skeleton, Stack } from "@mui/material";

/** Placeholder shown while the real candidate list is being fetched, so the
 * dialog never flashes stale data from a previous open before swapping to
 * the fresh list. */
const NeedAttentionAddFamiliesModalSkeleton = () => (
  <>
    <Skeleton variant="rounded" height={40} sx={{ mt: 1 }} />
    <Skeleton width={240} height={16} sx={{ mt: 1 }} />
    <Stack spacing={1} sx={{ mt: 2 }}>
      <Skeleton variant="rounded" height={56} />
      <Skeleton variant="rounded" height={56} />
      <Skeleton variant="rounded" height={56} />
    </Stack>
  </>
);

export default NeedAttentionAddFamiliesModalSkeleton;
